import { Controller } from '@hotwired/stimulus';

const DEFAULT_PREFERRED_COUNTRIES = ['FR', 'BE', 'CH', 'LU'];

const INVALID_NUMBER_MESSAGES = {
  fr: 'Le numéro renseigné doit correspondre à un téléphone mobile.',
  en: 'Please fill in a mobile phone number.',
  es: 'El número de teléfono debe ser un número de móvil.',
};

export default class PhoneInputController extends Controller {
  static targets = ['input'];

  connect() {
    if (!this.hasInputTarget) return;
    if (this.inputTarget.closest('.iti')) return;

    const $input = $(this.inputTarget);

    $input.intlTelInput({
      initialCountry: getCurrentLocale() === 'es' ? 'ES' : 'FR',
      preferredCountries: this.#readPreferredCountries(),
      separateDialCode: true,
      formatOnDisplay: true,
      autoHideDialCode: false,
      nationalMode: false,
      hiddenInput: 'full',
    });

    this.formElement = this.inputTarget.closest('form');

    if (this.formElement) {
      this.submitHandler = this.#handleSubmit.bind(this);
      this.formElement.addEventListener('submit', this.submitHandler);
    }
  }

  disconnect() {
    if (this.formElement && this.submitHandler) {
      this.formElement.removeEventListener('submit', this.submitHandler);
      this.formElement = null;
      this.submitHandler = null;
    }

    if (this.hasInputTarget && this.inputTarget.closest('.iti')) {
      $(this.inputTarget).intlTelInput('destroy');
    }
  }

  #readPreferredCountries() {
    const raw = this.inputTarget.dataset.preferredCountries;

    if (!raw) return DEFAULT_PREFERRED_COUNTRIES;

    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) && parsed.length ? parsed : DEFAULT_PREFERRED_COUNTRIES;
    } catch (e) {
      return DEFAULT_PREFERRED_COUNTRIES;
    }
  }

  #handleSubmit(event) {
    const $input = $(this.inputTarget);

    this.inputTarget.classList.remove('error');

    const validTypes = [
      intlTelInputUtils.numberType.MOBILE,
      intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE,
    ];

    const isValid = $input.intlTelInput('isValidNumber') &&
      validTypes.includes($input.intlTelInput('getNumberType'));

    if (isValid) {
      $input.val($input.intlTelInput('getNumber'));
      return;
    }

    const message = INVALID_NUMBER_MESSAGES[getCurrentLocale()] || INVALID_NUMBER_MESSAGES.en;
    toastr.error(message);
    event.preventDefault();
    this.inputTarget.classList.add('error');
  }
}
